import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { MeService } from './me.service';

/** Exige un utilisateur connecté (redirection vers Keycloak sinon) et charge son profil. */
export const authGuard: CanActivateFn = async (_route, state) => {
  // inject() uniquement avant le premier await (contexte d'injection).
  const auth = inject(AuthService);
  const me = inject(MeService);
  if (!auth.isAuthenticated) {
    await auth.login(state.url);
    return false;
  }
  await me.load();
  return true;
};

/** Réservé au rôle Admin. */
export const adminGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const me = await inject(MeService).load();
  return me.isAdmin ? true : router.createUrlTree(['/']);
};
